import React from "react";

import Container from "react-bootstrap/Container";

import FormLogin from "../components/Login/FormLogin";

const Login = () => {

	return (
		<>
			<Container>
				<h1 className="m-5">Fazer Login</h1>

				<FormLogin />
			</Container>
		</>
	);
};

export default Login;
